import { POST } from "../APiHelper/API";
import { formatted_date_for_backend } from "../../helper/Generic/dateTimeFormat";

export const getFavoritesFixture = (
  country_ids,
  start_time,
  end_time,
  competition_ids,
  term,
  onSuccess,
  onError
) => {
  const data = {
    country_ids: country_ids,
    start_time: formatted_date_for_backend(start_time),
    end_time: formatted_date_for_backend(end_time),
    competition_ids: competition_ids,
    term: term,
  };
  POST("/api/v1/fixtures/favorites", data, onSuccess, onError);
};
export const addFixtureToFavorites = (fixture_id, onSuccess, onError) => {
  const data = {
    fixture_id: fixture_id,
  };
  POST("/api/v1/fixtures/add_to_favorites", data, onSuccess, onError);
};
export const removeFixtureFromFavorites = (fixture_id, onSuccess, onError) => {
  const data = {
    fixture_id: fixture_id,
  };
  POST("/api/v1/fixtures/remove_from_favorites", data, onSuccess, onError);
};
